import dayjs from 'dayjs'

export const initialReportFormState = {
  reportCode: null,
  reportDate: null, // set to dayjs() at runtime via RESET
  notes: '',
  existingReportId: null,
  originalReportDate: null, // preserved from INIT_FROM_REPORT; used as old anchor for cascade
}

export const reportFormReducer = (state, action) => {
  switch (action.type) {
    case 'SET': return { ...state, [action.key]: action.value }
    case 'RESET': return { ...initialReportFormState, reportDate: dayjs() }
    case 'INIT_FROM_REPORT':
      // Populate form from an existing report (edit mode for single_submission types).
      // Preserves reportCode already set by the type selection.
      return {
        ...state,
        reportDate: action.report.created_at ? dayjs(action.report.created_at) : dayjs(),
        notes: action.report.notes ?? '',
        existingReportId: action.report.id,
        originalReportDate: action.report.created_at ?? null,
      }
    default: return state
  }
}
